import type { ZodType } from 'zod'
import type { ClientKind } from '@/kinds/kind'
import { apply, defaults, displayName, initialStatus, validate } from './apply'
import { profileSpec, profileStatus, type ProfileSpec } from './schema'

const Nothing = () => null

export const themeProfileKind: ClientKind<ProfileSpec, Record<string, never>> = {
  name: 'ThemeProfile',
  version: 1,
  // the theme of a newer version is kept as given, so the zod type is wider than ProfileSpec
  spec: profileSpec as unknown as ZodType<ProfileSpec>,
  status: profileStatus as never,
  defaults,
  validate,
  initialStatus,
  displayName,
  apply,
  actions: [],
  workspaceScoped: true,
  ListRow: Nothing,
  Detail: Nothing,
  Form: Nothing,
}

export * from './schema'
export type { ThemeProfileResource } from './apply'
